export function getImage(images, priority) {
    if (priority == null) {
        priority = [
            'medium',
            'shop_catalog',
            'woocommerce_thumbnail',
            'shop_single',
        ];
    }

    for (let i = 0, l = priority.length, key; i < l; ++i) {
        key = priority[i];
        if (images[key] == null) {
            continue;
        }

        return images[key];
    }

    return null;
}
